import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Error() {
  return (
    <div className="error-fixed-container">
      <Container fluid className="error-container">
        <Row className="justify-content-center align-items-center">
          <Col sm={8} md={6} lg={4} xl={5} className="text-center">
            <Image src='https://img.freepik.com/free-vector/business-man-depressed-stressed-watching-decrease-graph-stock-financial-trade-market-diagram_1150-39760.jpg?w=996&t=st=1712322381~exp=1712322981~hmac=978609a04911cf6f831a4de126711e3d12921b8f6546a18761e2c5d695ddcd07' fluid />
            <h1 className='error-message text-l fs-5'>Oops.! Sorry, Could not find the page you're looking for</h1>
            <Link to="/"><br />
              <Button variant='outline-primary' size='xl' className='fw-bolder'>Go Home</Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
